import instance from "../../api";

export const searchByPhoneAPI = {
  async search(body) {
    return await instance().post('/crm/crm_deals/client_search/', body)
  }
}